/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query'

import type { HomepageStats } from '../models'

import homepageStatsRetrieveMutator from '../../client'

/**
 * Provides statistics for the homepage, including minimum rake for GTO Wizard subscription
and maximum earnable rakeback percentage, based on user's location.
 */
export const homepageStatsRetrieve = (signal?: AbortSignal) => {
  return homepageStatsRetrieveMutator<HomepageStats>({
    url: `/api/v1/homepage/stats/`,
    method: 'GET',
    signal,
  })
}

export const getHomepageStatsRetrieveQueryKey = () => {
  return [`/api/v1/homepage/stats/`] as const
}

export const getHomepageStatsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof homepageStatsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof homepageStatsRetrieve>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getHomepageStatsRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof homepageStatsRetrieve>>> = ({ signal }) =>
    homepageStatsRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof homepageStatsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HomepageStatsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof homepageStatsRetrieve>>
>
export type HomepageStatsRetrieveQueryError = unknown

export function useHomepageStatsRetrieve<
  TData = Awaited<ReturnType<typeof homepageStatsRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof homepageStatsRetrieve>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof homepageStatsRetrieve>>,
        TError,
        Awaited<ReturnType<typeof homepageStatsRetrieve>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHomepageStatsRetrieve<
  TData = Awaited<ReturnType<typeof homepageStatsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof homepageStatsRetrieve>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof homepageStatsRetrieve>>,
        TError,
        Awaited<ReturnType<typeof homepageStatsRetrieve>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHomepageStatsRetrieve<
  TData = Awaited<ReturnType<typeof homepageStatsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof homepageStatsRetrieve>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHomepageStatsRetrieve<
  TData = Awaited<ReturnType<typeof homepageStatsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof homepageStatsRetrieve>>, TError, TData>>
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHomepageStatsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getHomepageStatsRetrieveSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof homepageStatsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof homepageStatsRetrieve>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getHomepageStatsRetrieveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof homepageStatsRetrieve>>> = ({ signal }) =>
    homepageStatsRetrieve(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof homepageStatsRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HomepageStatsRetrieveSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof homepageStatsRetrieve>>
>
export type HomepageStatsRetrieveSuspenseQueryError = unknown

export function useHomepageStatsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof homepageStatsRetrieve>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof homepageStatsRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHomepageStatsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof homepageStatsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof homepageStatsRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHomepageStatsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof homepageStatsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof homepageStatsRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useHomepageStatsRetrieveSuspense<
  TData = Awaited<ReturnType<typeof homepageStatsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof homepageStatsRetrieve>>, TError, TData>
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getHomepageStatsRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}
